<template>
  <div class="main">
    <div class="navbar-content">
      <Navbar />
    </div>
    <div class="main-content">
      <Home />
      <Divisoes id="divisoes" />
      <Portfolio id="servicos" />
      <AcaoSocial id="acao-social" />
      <Contato id="contato" />
      <Bottom />
    </div>
  </div>
</template>

<script>
import Divisoes from "./Divisoes.vue";
import Portfolio from "./Servicos/Portfolio.vue";
import AcaoSocial from "./AcaoSocial.vue";
import Bottom from "./Bottom.vue";
import Contato from "./Contato.vue";
import Home from "./Home.vue";
import Navbar from "../components/Navbar.vue";

export default {
  name: "Main",
  components: {
    Divisoes,
    Portfolio,
    AcaoSocial,
    Contato,
    Bottom,
    Home,
    Navbar,
  },
};
</script>

<style scoped>
.main-content {
  position: relative;
  width: 100%;
}

.navbar-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
}

@media screen and (max-width: 624px) {
  .main-content {
    width: 100vw;
  }
}
</style>